/* eslint-disable */
export default {
  rateExceeded: 'Request limit exceeded. App will resume in {ttl} seconds.',
} as const;

// @key: @#@"rateExceeded"@#@ @source: @#@"Request limit exceeded. App will resume in {ttl} seconds."@#@
